import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Outlet } from "react-router-dom";

/**
 * Shell for /dashboard/yard-management/* — matches Shipment / Orders module chrome
 * (lavender background, "Yard Overview" title row, optional accordion, then main content).
 */
const YardManagementLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="flex h-full min-h-0 max-w-full w-full flex-1 flex-col gap-0 bg-custom-bg-purple">
      <div
        className="mt-fluid-2 flex w-fit cursor-pointer select-none items-center gap-1 rounded-xl pl-fluid-2"
        onClick={() => setIsCollapsed((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsCollapsed((prev) => !prev);
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={!isCollapsed}
      >
        <h4 className="text-fluid-lg font-semibold text-acs-light-text transition-none dark:text-acs-dark-text">
          Yard Overview
        </h4>
        {isCollapsed ? (
          <ChevronRight
            className="h-[18px] w-[18px] text-[#223688] transition-none dark:text-[#6DE1C2]"
            aria-hidden
          />
        ) : (
          <ChevronDown
            className="h-[18px] w-[18px] text-[#223688] transition-none dark:text-[#6DE1C2]"
            aria-hidden
          />
        )}
      </div>

      <div className="fluid-0.5 flex min-h-0 flex-1 flex-col overflow-hidden">
        <div
          className={`overflow-hidden transition-none ease-in-out ${
            isCollapsed ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"
          }`}
        >
          {/* Reserved for future yard summary cards (see ShipmentList / OrderList) */}
        </div>
        <div className="min-h-0 flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default YardManagementLayout;
